import CopyButton from './CopyButton';

export default CopyButton;
export * from './CopyButton';
